import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface LocationMappingInput {
	partstraderId: string;
	/**
	 * Optional in the PT-additive flow. When omitted, each PT id becomes its own brand-new
	 * location doc (no CCC anchor). When present, behaves as the original onboarding
	 * mapping (PT ids grouped under a CCC anchor).
	 */
	cccId?: string;
	title?: string;
	address?: string;
	city?: string;
	state?: string;
	zip?: string;
}

interface AddLocationsResponse {
	locations: Array<{ _id: string; title: string }>;
	message?: string;
}

export const useAddLocationsFromMapping = () => {
	const sessionContext = useContext(SessionContext);

	return useMutation({
		mutationFn: async (mappings: LocationMappingInput[]) => {
			const { data } = await axios.post<AddLocationsResponse>(
				`${API_URL}/settings/location/add-from-mapping`,
				{ mappings },
				{ headers: { Authorization: sessionContext?.sessionId ?? '' } },
			);
			return data;
		},
	});
};
